"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SBTUpgradeableMock__factory = void 0;

var _ethers = require("ethers");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const _abi = [{
  inputs: [{
    internalType: "string",
    name: "name",
    type: "string"
  }, {
    internalType: "string",
    name: "symbol",
    type: "string"
  }],
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "Transfer",
  type: "event"
}, {
  inputs: [{
    internalType: "address",
    name: "owner",
    type: "address"
  }],
  name: "balanceOf",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "baseURIInternal",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "burn",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "existsInternal",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "name",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "ownerOf",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "safeMintInternal",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "data",
    type: "bytes"
  }],
  name: "safeMintWithDataInternal",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes4",
    name: "interfaceId",
    type: "bytes4"
  }],
  name: "supportsInterface",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "symbol",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "tokenURI",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "transferFrom",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];
const _bytecode = "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";

const isSuperArgs = xs => xs.length > 1;

class SBTUpgradeableMock__factory extends _ethers.ContractFactory {
  constructor(...args) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(name, symbol, overrides) {
    return super.deploy(name, symbol, overrides || {});
  }

  getDeployTransaction(name, symbol, overrides) {
    return super.getDeployTransaction(name, symbol, overrides || {});
  }

  attach(address) {
    return super.attach(address);
  }

  connect(signer) {
    return super.connect(signer);
  }

  static createInterface() {
    return new _ethers.utils.Interface(_abi);
  }

  static connect(address, signerOrProvider) {
    return new _ethers.Contract(address, _abi, signerOrProvider);
  }

}

exports.SBTUpgradeableMock__factory = SBTUpgradeableMock__factory;

_defineProperty(SBTUpgradeableMock__factory, "bytecode", _bytecode);

_defineProperty(SBTUpgradeableMock__factory, "abi", _abi);